import * as ClientActions from 'client/features/client/actions'
import _ from 'underscore'

const initialState = {
    all: [],
    current: null,
    search: null
}

const initializeState = () => Object.assign({}, initialState)

export default function client(state = initializeState(), action = {}) {
    let all = state.all
    let indexOfIssue
    switch (action.type) {

    case ClientActions.ClientsRequest.get.TYPES.SUCCESS:
        return { ...state, all: action.payload.clients }

    case ClientActions.ClientsRequest.post.TYPES.SUCCESS:
        return { ...state, all: [...all, action.payload.client], current: action.payload.client }


    case ClientActions.ClientsRequest.delete.TYPES.SUCCESS:
        return { ...state, current: null }
    
    case ClientActions.SET_CURRENT_CLIENT:
        if (!action._id)
            return { ...state, current: null }
        return { ...state, current: _.findWhere(state.all, { _id: action._id }) }
    
    case ClientActions.HiveRequest.post.TYPES.SUCCESS:
        indexOfIssue = _.findLastIndex(state.all, { _id: action.payload.client._id })
        all[indexOfIssue] = action.payload.client
        return { ...state, current: action.payload.client, all }

    case ClientActions.HiveRequest.put.TYPES.SUCCESS:
        indexOfIssue = _.findLastIndex(state.all, { _id: action.payload.client._id })
        all[indexOfIssue] = action.payload.client
        return { ...state, all }
    
    case ClientActions.HiveRequest.delete.TYPES.SUCCESS:
        indexOfIssue = _.findLastIndex(state.all, { _id: action.payload.client._id })
        all[indexOfIssue] = action.payload.client
        return { ...state, all, current: action.payload.client }

    case ClientActions.ClientsRequest.put.TYPES.SUCCESS:
        const index = _.findIndex(all, { _id: action.payload.client._id })
        if (index !== -1)
            all[index] = action.payload.client
        return { ...state, current: action.payload.client, all }
    
    case ClientActions.CLIENT_SEARCH_CHANGE:
        return { ...state, search: action.payload.search }

    default: 
        return state
    }
}


// WEBPACK FOOTER //
// ./src/client/features/client/reducers.js